<div class="multiple-fulfillment-container">
  <div class="multiple-fulfillment-container__header">
    <div class="multiple-fulfillment-container__header-title">
      Mark multiple orders as {{isPickingMode ? 'picked' : 'fulfilled'}}?
    </div>
    <div class="close-icon">
      <img alt="" (click)="onCancel()" src="assets/icons/x-delivery-services.svg" />
    </div>
  </div>
  <div class="text">
    @if (disableAction) {
    <div class="multiple-fulfillment-container__text">{{ updateIssueMessage}}</div>
    } @else {
    <div class="multiple-fulfillment-container__text">
      Heads up, you're {{isPickingMode ? 'picking' : 'fulfilling'}} multiple orders at once
      <br />
      <br />
      Are you sure?
    </div>
    }
  </div>

  <div class="multiple-fulfillment-container__actions">
    <pdq-button
      class="multiple-fulfillment-container__actions-cancel"
      (onClick)="onCancel()"
      label="Cancel"
      variant="light">
    </pdq-button>

    <pdq-button
      class="multiple-fulfillment-container__actions-fulfill"
      [disabled]="disableAction"
      [label]="label"
      [loading]="isLoading"
      (onClick)="approveButton()"
      variant="primary">
    </pdq-button>
  </div>
</div>
